import BaseRestService from "./BaseRestService";

class ButtonLibraryService extends BaseRestService {
  async getPermissions() {
    const url = `/api/v2/library/button/permissions`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async savePermissions(data) {
    const url = `/api/v2/library/button/permissions`;
    return this.client.post(
      url,
      { data },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async isCurrentUserInPermissions() {
    const url = `/api/v2/library/button/userpermission`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async getAllButtons() {
    const url = `/api/v2/library/button/all`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async createNewButton(data, callee) {
    const url = `/api/v2/library/button/create`;
    return this.client.post(
      url,
      { data, callee },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async editButton(data) {
    const url = `/api/v2/library/button/edit`;
    return this.client.post(
      url,
      { data },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async deleteButton(id) {
    const url = `/api/v2/library/button/delete`;
    return this.client.post(url, { id }, await this.buildJWTAuthAxiosConfig());
  }
}

export const buttonLibraryService = new ButtonLibraryService();
